import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Card, CardSection } from "cxa-components";
import { ClientLogo } from "@cxagroup/casper";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { retrieveQueryParams } from "cxa-utils";

const WebsiteMaintenanceContent = ({ intl, type }) => {
  const title =
    type === "TechnicalError"
      ? intl.formatMessage(messages.websiteMaintenance.technicalErrorTitle)
      : intl.formatMessage(messages.websiteMaintenance.underMaintenanceTitle);

  const message =
    type === "TechnicalError"
      ? intl.formatMessage(messages.websiteMaintenance.technicalErrorMessage)
      : intl.formatMessage(messages.websiteMaintenance.underMaintenanceMessage);

  return (
    <div>
      <img src="/assets/images/error-page.png" alt="under-maintenance" />
    </div>
  );
};

WebsiteMaintenanceContent.propTypes = {
  intl: PropTypes.object,
  type: PropTypes.string,
};

const WebsiteMaintenance = ({ intl, client, logoUrl, isAuthenticated, ...props }) => {
  const type = retrieveQueryParams().type;

  if (isAuthenticated) {
    return (
      <Card className="apl-website-offline">
        <WebsiteMaintenanceContent intl={intl} type={type} />
      </Card>
    );
  }

  return (
    <div className="login-maintenance">
      <WebsiteMaintenanceContent intl={intl} type={type} />
    </div>
  );
};

const mapStateToProps = ({ app: { client }, common: { logoUrl }, login: { isAuthenticated } }) => ({
  client,
  logoUrl,
  isAuthenticated,
});

WebsiteMaintenance.propTypes = {
  intl: PropTypes.object,
  client: PropTypes.string,
  logoUrl: PropTypes.string,
  isAuthenticated: PropTypes.bool,
};

export default injectIntl(connect(mapStateToProps)(WebsiteMaintenance));


// WEBPACK FOOTER //
// ./components/common/WebsiteMaintenance.js